import { render, staticRenderFns } from "./ConsumerChatScript.vue?vue&type=template&id=514d8a48"
import script from "./ConsumerChatScript.vue?vue&type=script&lang=ts"
export * from "./ConsumerChatScript.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports